import { render } from "./AdrUCCEAssistant.vue?vue&type=template&id=1d972c53"
import script from "./AdrUCCEAssistant.vue?vue&type=script&lang=js"
export * from "./AdrUCCEAssistant.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__